'use strict';

import React, { Component ,Fragment} from 'react';
import { ListItem, ListItemIcon, ListItemText, Typography, Button, TableBody, TableRow, TableCell, Box } from '@material-ui/core';
import { AccountCircle, Close, Create } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
import InputText from '../../../commonModules/interface/form-input-inline';
var    $ = require('jquery');

class ProfileAboutItemPerso extends Component{
    state = {
            // Initiate Time for the chart
            update: false,
            error: '',
            styleError: {
                color: 'white'
            },
            // adress: '',
            // city: '',
            // country: '',
            // phone: this.props.phone,
            newInfo:{
                name: this.props.name || "",
                adress: this.props.adress || "",
                phone: this.props.phone || "",
                phone2: this.props.phone2 || "",
                email: this.props.email || "",
                phone: this.props.phone  || ""
            }
        }

    componentWillUnmount() {
        try {
        } catch (e) { 
            console.log(e);
        }
    }
        
    showUpdate = (e) => {
        e.preventDefault();
        this.setState({ update: !this.state.update});
    }

    closeUserInfo = (e) => {
        e.preventDefault();
        this.setState({ update: false});
    }

    handleChange(e){  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        const intField = [ "phone", "phone2"]
        if( ( intField.includes(field) && value === "") || 
            regex.test(value) || 
            !intField.includes(field) 
        ){
            this.setState({
                ...this.state,
                newInfo:{
                    ...this.state.newInfo,
                    [field]:value
                }
            })
        }
    }
    handleSubmit = async () => {
        let formData = {}
        await Object.keys(this.state.newInfo).map( field => {
            if (this.state.newInfo[field] !== "" ){
                formData[field] = this.state.newInfo[field]
            }
        })
        try {
            const infos = await fetch('/schema/updateUserOld',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    "data":formData,
                    "boxID":this.props.boxId,
                    "idForm":"user"
                }),
                
                credentials: 'same-origin',
            });
            let body = await infos.json();                
            console.log("[INFO] submit update profile user", body);  
            if(body.errorCode === 200){
                this.setState({ update: true});
            }

        } catch (error) {
            console.log("[ERROR] submit update profile user",error)
            return
        }
        
    }

    render() {
        console.log("[STATE]", this.state);
        
        return (
            <MiniCard 
                title="User Info"
                action={this.state.update ? 
                    <Close onClick={this.showUpdate} /> : 
                    <Create onClick={this.showUpdate} />
                }
                avatar={<AccountCircle />}
                submitAction={this.state.update && 
                    <Fragment>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit}>Valider</Button>
                        <Button onClick={this.closeUserInfo}>Annuler</Button>
                    </Fragment>
                }
            >
                <TableLayout>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th">Name</TableCell>
                            <TableCell>{this.props.name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Gender</TableCell>
                            <TableCell>{this.props.gender}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Mobile Phone 1</TableCell>
                            <TableCell>{this.props.phone}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Mobile Phone 2</TableCell>
                            <TableCell>{this.props.phone2}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Email Address</TableCell>
                            <TableCell>{this.props.email}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Address</TableCell>
                            <TableCell>{this.props.adress}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Carte Id</TableCell>
                            <TableCell>{this.props.carteId}</TableCell>
                        </TableRow>
                    </TableBody>
                </TableLayout>
                {this.state.update &&
                    <Box p={1}>
                        <InputText type="text" className="form-control" value={this.state.newInfo.name} label="Name" name="name" onChange={this.handleChange}/>
                        <InputText type="text" className="form-control" value={this.state.newInfo.phone} label="Phone 1" name="phone" onChange={this.handleChange}/>
                        <InputText type="text" className="form-control" value={this.state.newInfo.phone2} label="Phone 2" name="phone2" onChange={this.handleChange}/>
                        <InputText type="text" className="form-control" value={this.state.newInfo.email} label="Email" name="email" onChange={this.handleChange}/>
                        <InputText type="text" className="form-control" value={this.state.newInfo.adress} label="Adress" name="adress" onChange={this.handleChange}/>
                    </Box>
                    }
            </MiniCard>
        )
    }
};
export default ProfileAboutItemPerso
